export const tickerItems = [
  "本页线路每 5 分钟自动校验一次，当前 4 条入口全部可用",
  "主线入口今日已完成第 128 次可用性检测，平均响应 0.8s",
  "新增备用地址已同步至更新日志，建议同时收藏两条以上线路",
  "若页面加载缓慢，请切换到速度更快的高速线路",
];

export const navLinks = [
  { label: "最新入口", href: "#entries" },
  { label: "备用地址", href: "#entries" },
  { label: "热度榜", href: "#ranking" },
  { label: "专题合集", href: "#collections" },
  { label: "话题墙", href: "#topics" },
  { label: "更新日志", href: "#logs" },
];

export const entries = [
  {
    id: "line-main",
    name: "主线入口",
    tag: "推荐",
    status: "smooth" as const,
    speed: "极速",
    latency: "0.6s",
    note: "官方主线，日常访问优先使用",
  },
  {
    id: "line-fast",
    name: "高速线路",
    tag: "移动端优选",
    status: "smooth" as const,
    speed: "快速",
    latency: "0.8s",
    note: "移动网络下打开更稳，适合手机收藏",
  },
  {
    id: "line-backup-1",
    name: "备用地址一",
    tag: "常规",
    status: "busy" as const,
    speed: "中等",
    latency: "1.4s",
    note: "主线拥挤时切换，晚间高峰表现更好",
  },
  {
    id: "line-backup-2",
    name: "备用地址二",
    tag: "长期有效",
    status: "smooth" as const,
    speed: "流畅",
    latency: "0.9s",
    note: "长期稳定线路，适合作为长期备用",
  },
  {
    id: "line-backup-3",
    name: "备用地址三",
    tag: "临时",
    status: "maintain" as const,
    speed: "维护中",
    latency: "--",
    note: "线路维护升级中，预计今日 18:00 恢复",
  },
];

export const rankingList = [
  { rank: 1, title: "本周吃瓜热度最高的事件合集", tag: "合集", heat: 98640, trend: "up" as const },
  { rank: 2, title: "被反复转发的三条爆料原文梳理", tag: "爆料", heat: 81230, trend: "up" as const },
  { rank: 3, title: "网友票选的年度十大热门话题", tag: "榜单", heat: 76510, trend: "flat" as const },
  { rank: 4, title: "最新专题：从热帖看评论风向", tag: "专题", heat: 64380, trend: "up" as const },
  { rank: 5, title: "老牌热门合集的回顾与更新", tag: "回顾", heat: 52890, trend: "down" as const },
  { rank: 6, title: "话题墙新增的六个讨论方向", tag: "话题", heat: 47220, trend: "up" as const },
];

export const collections = [
  {
    id: "col-1",
    title: "跟拍与现场合集",
    subtitle: "路透与现场图文的高清汇总，按时间线整理，一次看全来龙去脉。",
    count: 128,
    tags: ["现场", "时间线", "图文"],
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20cover%20art%20of%20a%20playful%20paparazzi%20theme%2C%20camera%20lens%20and%20bright%20flash%20bursts%20rendered%20as%20warm%20vermillion%20and%20amber%20paper%20cut%20shapes%2C%20cream%20backdrop%2C%20bold%20graphic%20magazine%20poster%2C%20no%20text&width=800&height=600&seq=mas-col-01&orientation=landscape",
  },
  {
    id: "col-2",
    title: "热点复盘专题",
    subtitle: "把散落的热帖按事件归类，配上时间轴，快速补齐你错过的细节。",
    count: 94,
    tags: ["复盘", "归类", "细节"],
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20cover%20art%20of%20a%20hot%20topic%20flame%20motif%20in%20warm%20vermillion%20and%20amber%2C%20layered%20torn%20paper%20texture%2C%20cream%20background%2C%20bold%20editorial%20poster%20illustration%2C%20no%20text&width=800&height=600&seq=mas-col-02&orientation=landscape",
  },
  {
    id: "col-3",
    title: "评论区风向合集",
    subtitle: "精选高赞评论与争议讨论，帮你在短时间内看清不同立场的声音。",
    count: 76,
    tags: ["评论", "风向", "观点"],
    cover:
      "https://readdy.ai/api/search-image?query=stylized%20cover%20art%20of%20overlapping%20chat%20bubbles%20in%20warm%20red%20and%20gold%2C%20torn%20paper%20texture%2C%20cream%20backdrop%2C%20bold%20graphic%20magazine%20cover%20illustration%2C%20no%20text&width=800&height=600&seq=mas-col-03&orientation=landscape",
  },
  {
    id: "col-4",
    title: "热度趋势榜",
    subtitle: "按热度变化与讨论量排序，每周更新一次，一眼看出谁在升温。",
    count: 52,
    tags: ["榜单", "趋势", "周更"],
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20cover%20art%20of%20a%20rising%20trend%20chart%20arrow%2C%20warm%20crimson%20and%20amber%20geometric%20shapes%2C%20cream%20paper%20texture%2C%20bold%20editorial%20poster%2C%20no%20text&width=800&height=600&seq=mas-col-04&orientation=landscape",
  },
];

export const topics = [
  { name: "最新爆料", heat: 9860, hot: true },
  { name: "现场路透", heat: 8420, hot: true },
  { name: "评论风向", heat: 7310, hot: false },
  { name: "合集整理", heat: 6980, hot: false },
  { name: "热帖追踪", heat: 6240, hot: false },
  { name: "话题投票", heat: 5710, hot: false },
  { name: "年度盘点", heat: 5230, hot: false },
  { name: "新旧地址", heat: 4890, hot: true },
  { name: "吃瓜日历", heat: 4420, hot: false },
  { name: "避坑提示", heat: 3980, hot: false },
  { name: "高赞评论", heat: 3560, hot: false },
  { name: "备用线路", heat: 3120, hot: false },
];

export const updateLogs = [
  {
    date: "2026-09-10 14:20",
    title: "同步第 3 条备用地址",
    desc: "新增长期备用线路，主线拥挤时可自动分流，建议一并收藏。",
    badge: "本次更新",
  },
  {
    date: "2026-09-08 10:05",
    title: "更换主线入口域名",
    desc: "主线入口更换为当前解析更快的域名，旧地址仍短暂保留跳转。",
    badge: "入口更换",
  },
  {
    date: "2026-09-05 21:40",
    title: "移动端线路提速",
    desc: "优化移动网络下的加载表现，手机端打开平均快约 0.4 秒。",
    badge: "性能",
  },
  {
    date: "2026-09-01 09:15",
    title: "月度可用性报告",
    desc: "8 月全线平均可用率 99.2%，共处理 5 次临时线路调整。",
    badge: "月报",
  },
];

export const faqs = [
  {
    q: "爱黑料网的入口为什么会变？",
    a: "受网络环境与线路调整影响，官网入口会不定期更换。本页会同步更新当前可用线，建议收藏本页以便随时获取新地址。",
  },
  {
    q: "打不开页面怎么办？",
    a: "先切换到备用地址一或备用地址二，通常可以正常访问；若全部线路都异常，请稍后再试或刷新本页查看最新入口。",
  },
  {
    q: "如何第一时间拿到新地址？",
    a: "收藏本页即可，最新入口与备用地址会在更新日志中记录时间，也建议同时保存两条以上线路，避免单点失效。",
  },
  {
    q: "备用地址和主线入口有区别吗？",
    a: "内容一致，区别在于线路负载与速度。主线入口日常更优，备用地址用于分流与应急，二者搭配使用体验最好。",
  },
];

export const footerSections = [
  {
    title: "入口导航",
    links: ["最新入口", "备用地址一", "备用地址二", "长期线路"],
  },
  {
    title: "内容分区",
    links: ["专题合集", "热度榜单", "话题墙", "更新日志"],
  },
  {
    title: "使用帮助",
    links: ["打不开怎么办", "如何收藏本页", "线路校验说明", "常见问题"],
  },
];

export const stats = [
  { label: "今日线路校验", value: "128", unit: "次" },
  { label: "当前可用入口", value: "4", unit: "条" },
  { label: "本月可用率", value: "99.2", unit: "%" },
  { label: "平均响应", value: "0.8", unit: "s" },
];